// eslint-disable-next-line simple-import-sort/imports
import React from 'react';

import 'styles/common/popup.scss';
import ListItem from 'onboarding/common/forms/common/ListItem';

export class Popup extends React.Component {
  onClickHandler = (item) => void this.props.onSelectItem(item);

  render() {
    return (
      <div>
        <div className="dark-overlay popup-bg-in" />
        <div className="popup-wrap popup-in">
          <div className="content-wrap">
            <div className="poppup-shadow">
              <div className="popup-header">
                {this.props.title}
                <button className="popup-header-button" onClick={this.props.onClose} />
              </div>
              <div className="popup-content-wrap">
                {this.props.items.map((item) => (
                  <ListItem item={item} onClickHandler={this.onClickHandler} key={item.id} />
                ))}
              </div>
              <div className="popup-footer" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Popup;
